import React from 'react';

import DocumentHead from 'components/DocumentHead';
import axios from 'utils/axios';
import ProfileLinks from 'components/links/ProfileLinks';

const LinksPage = ({ profile }) => {
  const url = `${process.env.NEXT_PUBLIC_URL}/${profile.username}`;
  const title = 'Check out my link page on GigSocial';
  const description = `${profile.username} | GigSocial`;

  return (
    <>
      <DocumentHead>
        <title>{profile.display_name} | GigSocial</title>

        <meta name="robots" content="noindex" />
        <meta property="og:title" content={title} key="og:title" />
        <meta property="twitter:title" content={title} key="twitter:title" />

        {description && (
          <>
            <meta property="og:description" content={description} key="og:description" />
            <meta property="twitter:description" content={description} key="twitter:description" />
          </>
        )}

        {profile.avatar_url && !profile.adult && (
          <>
            <meta property="og:image" content={profile.avatar_url} key="og:image" />
            <meta name="twitter:image" content={profile.avatar_url} key="twitter:image" />
          </>
        )}

        <meta property="og:url" content={url} key="og:url" />
        <meta property="twitter:url" content={url} key="twitter:url" />
      </DocumentHead>

      <ProfileLinks profile={profile} />
    </>
  );
};

export const getServerSideProps = async context => {
  const { params } = context;
  const { username } = params;

  try {
    const response = await axios.get(`/v1/profiles/${username}/links`);
    if (response.data.links.length === 0) return { redirect: { destination: '/' } };

    return { props: { profile: response.data } };
  } catch (error) {
    return {
      redirect: {
        destination: '/',
        permanent: false,
      },
    };
  }
};

export default LinksPage;
